import { Language as ClientLanguage } from '@contracts/client/Language';
import { Language as I18nLanguage } from '@src/common/i18n/Language';

export const convertClientLanguageToI18n = (
  clientLanguage: ClientLanguage,
): I18nLanguage => {
  switch (clientLanguage) {
    case ClientLanguage.FRENCH:
      return I18nLanguage.FR;
    case ClientLanguage.ENGLISH:
      return I18nLanguage.EN;
    default:
      return I18nLanguage.EN;
  }
};
